module.exports = __webpack_public_path__ + "img/3-5-IMG_3001.04bd4b2d.png";